import React from 'react';

const AppFooter = ({ apiDocUrl }) => {
  return (
    <footer style={{
      width: '100%',
      backgroundColor: '#F8FAFC',
      borderTop: '1px solid #E2E8F0',
      padding: '12px 0',
      flexShrink: 0
    }}>
      <div style={{
        maxWidth: '1100px',
        margin: '0 auto',
        padding: '0 24px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '8px'
      }}>
        <div style={{
          fontSize: '12px',
          color: '#9CA3AF',
          textAlign: 'center'
        }}>
          2025 <a 
            href="https://smartly.ai" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{
              color: '#6B7280',
              textDecoration: 'none',
              transition: 'all 0.2s ease',
              fontWeight: 'normal'
            }}
            onMouseEnter={(e) => {
              e.target.style.textDecoration = 'underline';
              e.target.style.fontWeight = 'bold';
            }}
            onMouseLeave={(e) => {
              e.target.style.textDecoration = 'none';
              e.target.style.fontWeight = 'normal';
            }}
          >
            Smartly.ai
          </a>, all rights reserved
        </div>
      </div>
    </footer>
  );
};

export default AppFooter;
